import React from 'react';
import { AdvertorialProductWidgetLayout } from './AdvertorialProductWidgetLayout';
import { AdvertorialProductDefaultLayout } from './AdvertorialProductDefaultLayout';

export interface AdvertorialProductProps {
  title: string;
  description?: string;
  btn_label?: string;
  disclosure_link?: string;
  features?: {
    advertorial_feature_label?: string;
    advertorial_feature_value?: string;
  }[];
  items?: {
    advertorial_item_label?: string;
    advertorial_item_value?: string;
  }[];
  image: string;
  link: string;
  layout?: 'default' | 'widget';
  product_name?: string;
}

export const AdvertorialProduct: React.FC<AdvertorialProductProps> = ({
  btn_label,
  description,
  disclosure_link,
  features,
  image,
  items,
  layout = 'default',
  link,
  product_name,
  title,
}) => {
  return (
    <div className="my-2">
      {layout === 'widget' ? (
        <AdvertorialProductWidgetLayout
          btn_label={btn_label}
          description={description}
          disclosure_link={disclosure_link}
          features={features}
          image={image}
          items={items}
          link={link}
          product_name={product_name}
          title={title}
        />
      ) : (
        <AdvertorialProductDefaultLayout
          btn_label={btn_label}
          description={description}
          image={image}
          items={items}
          link={link}
          title={title}
        />
      )}
    </div>
  );
};
